"use client";

import { c as _c } from "react/compiler-runtime";
import Footer from "@/components/footer/Footer";
import { usePathname } from "next/navigation";
import useDeviceInfo from "../../hooks/useDeviceInfo";
export default function FooterWrapper() {
  const $ = _c(1);
  const {
    isApp
  } = useDeviceInfo();
  const pathname = usePathname();
  const myFeedRoutes = ["/my-feed", "/feed"];
  const hideFooter = isApp || myFeedRoutes.some(path_0 => pathname?.startsWith(path_0)) || ["/waves", "/messages", "/notifications", "/open-mobile"].some(path => pathname?.startsWith(path));
  if (hideFooter) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Footer />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}